// @flow
import ElJurDnevnik from './ElJurDnevnik';

export default ElJurDnevnik;
